export default {"src":"/_next/static/media/Group 48097641.960c5202.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};